import { useTranslation } from "react-i18next";

import { Button } from "src/core/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/core/components/ui/dialog";

type CommentModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  lastDraftAuditEventComment: string;
};

export default function CommentModal({
  open,
  setOpen,
  lastDraftAuditEventComment,
}: CommentModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent hideCloseButton>
        <DialogHeader>
          <DialogTitle>{t("folder.renvoi.motifCompletion")}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="whitespace-pre-wrap">
          {lastDraftAuditEventComment}
        </DialogDescription>
        <DialogFooter className="justify-center">
          <Button onClick={() => setOpen(false)}>{t("global.form.close")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
